module.exports = __webpack_public_path__ + "static/media/hot.7ef93922.jpg";